/* eslint-disable no-unused-vars */
import React, { Component , useRef}  from "react";
// import  { useRef   }  from "react";
// import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from 'moment';
import validator from 'validator';
import MainLayout from "../layout/main-layout";
import Header from '../layout/Header';
import Left from '../layout/Left';
import DatePicker from "react-datepicker";
import valid from "card-validator";
import "react-datepicker/dist/react-datepicker.css";
import SignatureCanvas from 'react-signature-canvas'
import NumberFormat from 'react-number-format';
import { useParams } from 'react-router-dom';



import { updatePassword,getOtp,verifyClientData,setPaymentInfo,getClientAgreement,setClientAgreement} from '../../actions/payActions'

class ForgotPassword extends Component {

    constructor(props){
        super(props);
        this.state={
            error:'',
            errors:{},
            formData:{Payment_Type:"",PaymentMethod:""},
            login:true,
            message:"",
            otp:"",
            dateOfBirth:"",
            clientACTId:"",
            client_info:"",
            verify_client:false,
            Payment_Type:"",
            

        }
    }

   


    componentDidMount() { 
        // this.props.updatePassword(newList, this.props.history);

        var myCurrentDate=new Date();
        // const { id } = useParams();

        // console.log('id--------- ',id);
        console.log('id--------- ',this.props.match.params.id);
        var myFutureDate=new Date(myCurrentDate);
        this.setState({myFutureDate:myFutureDate})
        if(this.props.match.params.id != null){
            var clientId = this.props.match.params.id
            this.props.getClientAgreement(clientId, this.props.history);
    
        }
        

        // console.log('clientACTId ---------- ', localStorage.getItem('clientACTId'));

        // this.setState({clientACTId:localStorage.getItem('clientACTId')})

         
    }

    fetchData = id => {
        // ...
    };


   

    onChange = (e) => {  
        this.state.formData[e.target.id] = e.target.value; 
        // console.log('form vlaue=>', this.state.formData);
    }
    

    datechange(e){
        // new Date(e);
        this.state.formData['dateOfBirth'] = Moment(e).format('MM/DD/YYYY');
        // consol
        this.setState({dateOfBirth:e})
    }

    checkRadio = (e) => {
        if(e.target.id == "credit_card"){
            this.state.formData['CreditCard'] = true; 
            this.setState({CreditCard:e.target.value})
            
            this.state.formData['PaymentMethod'] = 'Credit Card';
            this.state.formData['PaymentMethod'] = 'Credit Card';
            // this.state.formData["Credit_Card_Number"] = this.state.card_info['Credit_Card_Number']
            // this.state.formData["CVV"] = this.state.card_info['CVV']
            // this.state.formData["Credit_Card_Holder_First_Name"] = this.state.card_info['Credit_Card_Holder_First_Name']
            // this.state.formData["Credit_Card_Holder_Last_Name"] = this.state.card_info['Credit_Card_Holder_Last_Name']
            // this.state.formData["Month_of_Expiry"] = this.state.card_info['Month_of_Expiry']
            // this.state.formData["Year_of_Expiry"] = this.state.card_info['Year_of_Expiry']

        }

        if(e.target.id == "shipment"){
            this.state.formData['CreditCard'] = false; 
            this.setState({CreditCard:e.target.value})
            this.state.formData['PaymentMethod'] = 'Check';

            // console.log('CreditCard =>', this.state.CreditCard)
        }

        if(e.target.id == "ACH_payment"){
            this.state.formData['CreditCard'] = false; 
            this.setState({CreditCard:e.target.value})
            this.state.formData['PaymentMethod'] = 'ACH Payment';
            this.state.formData['PaymentMethod'] = 'ACH Payment';
            // this.state.formData["Credit_Card_Number"] = ""
            // this.state.formData["CVV"] = ""
            // this.state.formData['Credit_Card_Holder_First_Name'] = ""
            // this.state.formData['Credit_Card_Holder_Last_Name'] = ""
            // this.state.formData['Month_of_Expiry'] = ""
            // this.state.formData['Year_of_Expiry'] = ""
      


            // console.log('CreditCard =>', this.state.CreditCard)
        }

        this.setState({Payment_Type:e.target.value})
        this.state.formData['Payment_Type'] = e.target.value; 

        
        // console.log('CreditCard =>', this.state.CreditCard)
        // console.log('target id  =>', e.target.id)
    }


    numberFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'USD'
        }).format(value);

    componentWillReceiveProps(nextProps) {
        console.log('nextProps ----------',nextProps); 


        if(nextProps.page_name.client_agreement){
            var row = nextProps.page_name.client_agreement;
            this.state.formData['ClientId'] = row.Id;
            this.state.formData['Annual_Banking_Fee_Amount__c'] = row.Annual_Banking_Fee_Amount__c;
            this.state.formData['Bio_Insurance_Fee_Amount__c'] = row.Bio_Insurance_Fee_Amount__c;
            this.state.formData['Down_Payment__c'] = row.Down_Payment__c;
            this.state.formData['Initial_Processing_Fee_Amount__c'] = row.Initial_Processing_Fee_Amount__c;
            this.state.formData['Interest_Rate__c'] = row.Interest_Rate__c;
            this.state.formData['Number_Of_Installments__c'] = row.Number_Of_Installments__c;
            this.state.formData['Total_Amount_Financing__c'] = row.Total_Amount_Financing__c;
            this.state.formData['Total_Monthly_Payment_Amount__c'] = row.Total_Monthly_Payment_Amount__c;
            this.state.formData['Name'] = row.Name;
            this.state.formData['Patient_ID__c'] = row.Patient_ID__c;
            this.state.formData['NB_Finance_Agreement_Completed__c'] = row.NB_Finance_Agreement_Completed__c;
            
            

        }

        
        if(nextProps.page_name.set_client_agreement){
            this.setState({loading:false});

            this.setState({agreement_response:true})

        }
      

       


   
 

        
        }

    sendOtp = (e) => {
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;

        if(!fields["Email"]){
            formIsValid = false;
            errors["Email"] = "Please enter email";
            let element = document.getElementById("Email");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["firstName"]){
            formIsValid = false;
            errors["firstName"] = "Please enter firstName";
            let element = document.getElementById("firstName");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["dateOfBirth"]){
            formIsValid = false;
            errors["dateOfBirth"] = "Please enter dateOfBirth";
            let element = document.getElementById("dateOfBirth");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        // console.log('formIsValid --- ', formIsValid)

        this.setState({errors: errors});

        if(formIsValid){
            // this.setState({ loading: true });  
            const newList = {firstName:this.state.formData['firstName'], dateOfBirth:this.state.formData['dateOfBirth'],email:this.state.formData['Email'] };
            // console.log("newlist=>", newList);
            this.props.getOtp(newList, this.props.history);
            }
    }

    checkradio2 = (e) => {
        this.state.formData['client_info'] = e.target.id;
        this.setState({client_info:e.target.id})
    
        // console.log('client info = ', this.state.client_info)
        
    }
    
    datechange2(e){
        // new Date(e);
        this.state.formData['ClientDob'] = Moment(e).format('MM/DD/YYYY');
        // console.log('selected date =>', this.state.formData['ClientDob']);
        this.setState({ClientDob:e})
    }

    clear = () => {
        this.sigPad.clear()
        this.setState({ trimmedDataURL: null })
        this.setState({success_sign_msg:''});

      }
    
      trim = () => {
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;

        console.log('Signature --------- ',fields["Signature"]);
            
            this.setState({ trimmedDataURL: this.sigPad.getTrimmedCanvas()
                .toDataURL('image/png') })
                this.state.formData['Signature'] = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
                this.setState({success_sign_msg:'Signature accepted successfully.'});
        
                
                console.log('msg------ ',this.state.success_sign_msg);
            
           
            
        }
    


    onSubmit = (e) => {              
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;

        if(!fields["ClientId"]) {
            formIsValid = false;
            errors["Signature"] = "Client id is not valid";
            // console.log('errors',errors);
            let element = document.getElementById("Signature");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }

        if(!fields["Signature"]) {
            formIsValid = false;
            errors["Signature"] = "Please sign and click on check button.";
            // console.log('errors',errors);
            let element = document.getElementById("Signature");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }

        

 

        this.setState({errors: errors});
        
        if(formIsValid){
            // this.setState({ loading: true });  

            console.log(' formData ------- ', this.state.formData);
            // const newList = this.state.formData;
           
            
            
            // newList['PhysicianId'] = this.state.paymentInfo['PhysicianId']
            var newList = {ClientId:fields["ClientId"],signatureData:fields["Signature"],NBAgreementCompleted:true};

            console.log('newlist --------- ',newList);
            this.setState({loading:true})
             this.props.setClientAgreement(newList, this.props.history);
            }

    }    

    render() {
        return (
            <MainLayout>
                <title>American Cell Technology</title>
                {/* <Header></Header> */}
                <div className="login-wrapper">
                    <div className="">
                        <div className="login-logo-area"><img src="../images/VitalCells-Log.png" alt="" /></div>
                        { (this.state.loading)?
                    <div class="loading-div">
                        <div class="loading-img"><img src="../images/spinner.svg" alt="" /></div>
                    </div>:""}
                        { (this.state.agreement_response || this.state.formData['NB_Finance_Agreement_Completed__c'] == true)?
                    <div className="col-md-12">
                        <h5 style={{paddingTop:"10px"}}><i>Newborn Agreement is Updated Sucessfully</i> </h5>
                    </div>:
                        <div className="login-box pay_info" >
                        {(this.state.error != "")?<span style={{color:'red'}}> {this.state.error} </span>:''}  
                            {(this.state.message != "")?<span style={{color:'green'}}> {this.state.message}</span>:''}                            
                            <form className="needs-validation" noValidate onSubmit={this.onSubmit}>
                             <div style={{textAlign:'center'}}>
                             <h3 className="">VitalCells Payment Plan Addendum</h3>
                             <p><i>American Cell Technology LLC dba VitalCells </i></p>
                             </div>
                             <br/>

                            <h2 className="title-2">Payment Plan Addendum </h2>
                            <p>
                            American Cell Technology LLC dba VitalCells (“ACT”) is pleased to offer clients an extended payment option through this Payment Plan Addendum (the “Addendum”) to the Agreement. No credit check will be required, and payments will be made directly to ACT via credit card or ACH transfer.
                            </p>
                            <br/>

                            <h2 className="title-2">Definitions:</h2>
                            <p>Any capitalized terms used in this Addendum that are not defined herein, shall have the meaning ascribed to such term in the Agreement. </p>
                            <p>“Agreement” means that certain ACT Newborn Client Stem Cell Storage Agreement between ACT and Client, to which this Addendum refers. </p>

                            <p>
                            "Client" means each person who has signed this Addendum in the client signature box below. This Addendum also uses the terms "you" and "your" to refer to the Client(s). 
                            </p>
                            <br/>

                            <h2 className="title-2">Payment Plan Agreement Fees: </h2>
                             <p>Once the Client completes enrollment and executes the Agreement, an initial $250 non-refundable deposit will be charged immediately. The remaining balance due under the Agreement will be charged on the terms set forth below: </p>

                             <h2 className="title-2">Payment Plan Agreement Terms: </h2>
                             {/* <p>Initial Non-Refundable Deposit of $250.00 due at signup </p> */}

                        <table width="100%" className="table table-bordered">
                            
                            <tr>
                             <td>Initial Processing Fee: </td>   
                             <td><b> {this.numberFormat(this.state.formData['Initial_Processing_Fee_Amount__c'])}  </b></td>   
                            </tr>
                            <tr>
                             <td>Bio-Insurance (prepaid cells) Fee:  </td>   
                             <td><b> {this.numberFormat(this.state.formData['Bio_Insurance_Fee_Amount__c'])} </b></td>   
                            </tr>
                            <tr>
                             <td>Annual Banking Fee: </td>   
                             <td><b> {this.numberFormat(this.state.formData['Annual_Banking_Fee_Amount__c'])} </b></td>   
                            </tr>
                            <tr>
                             <td>Total Amount:  </td>   
                             <td><b> {this.numberFormat(this.state.formData['Initial_Processing_Fee_Amount__c']+this.state.formData['Bio_Insurance_Fee_Amount__c']+this.state.formData['Annual_Banking_Fee_Amount__c'] )} </b></td>   
                            </tr>
                            <tr>
                             <td>Initial Non-Refundable Deposit Paid:  </td>   
                             <td><b> $250.00 at signup </b></td>   
                            </tr>
                            <tr>
                             <td>Initial Down Payment at Birth:   </td>   
                             <td><b> {this.numberFormat(this.state.formData['Down_Payment__c'])} </b></td>   
                            </tr>
                            
                            <tr>
                             <td>Amount Financed: </td>   
                             <td><b> {this.numberFormat(this.state.formData['Total_Amount_Financing__c'])}</b></td>   
                            </tr>
                            <tr>
                             <td>Interest Rate:  </td>   
                             <td><b> {this.state.formData['Interest_Rate__c']}%</b></td>   
                            </tr>
                            <tr>
                             <td>Monthly Payment: </td>   
                             <td><b> {this.numberFormat(this.state.formData['Total_Monthly_Payment_Amount__c'])} </b></td>   
                            </tr>
                        </table>
                    <p>Note: If paying by credit card, a 3% credit card processing fee will be added. </p>

                    <br/>

                   
                    <h2 className="title-2">Payments shall be remitted as follows: </h2>
                    <p>Monthly Payments are automatically charged monthly, commencing within one (1) month following the Initial Down Payment or at the time of birth if there is no Initial Down Payment.  </p>
                    <br/>
                    
                    {/* <p>
                        Payments of <b> {this.numberFormat(this.state.formData['Total_Monthly_Payment_Amount__c'])} </b>  per month are automatically charged monthly, within one (1) month following the down payment or at the time of birth, which is inclusive of <b> {(this.state.formData['Interest_Rate__c'])}</b>% interest 
                        </p> */}

                    <h2 className="title-2">Annual Storage Plans </h2>
                    <p>Please note that only 1 year of annual storage is included with initial processing. Depending on the payment plan chosen (details above in this Addendum), the payment plan may cover additional annual fee(s) due. If your payment plan does not include additional year(s) of storage, you will be automatically charged the yearly annual fee(s) during the baby's birth month separately from your payment plan amount. </p>
                    <br/>
                    
                    <h2 className="title-2">Payment Method  </h2>
                    <p> ACT will automatically debit the ACH account or charge the credit card provided at signup, or any updated payment method provided by the Client. <br/>
Preferred Methods: We accept ACH Transfer with no additional fees. <br/>
Credit Card Payments: All credit card transactions are subject to a 3.0% Processing Fee.  </p>
                    <br/>

                    <h2 className="title-2">5-Day Grace Period </h2>
                    <p>We understand that credit card updates or banking delays happen. We provide a 5-day grace period from your scheduled due date to resolve any payment issues without penalty.  </p>
                    <br/>

                    <h2 className="title-2">Late Administrative Fees  </h2>
                    <p>If the balance remains unpaid after the 5-day grace period, the following charges apply:  </p>
                    <ul>
                        <li>Day 6: A $50.00 administrative late charge that will be applied to cover the cost of account recovery and manual processing.</li>
                        <li>Recurring: An additional $50.00 will be applied every fourteen (14) days thereafter until the account is brought current</li>
                    </ul>
                    <br/>

                    <h2 className="title-2">Bank Disruption Fee (NSF)  </h2>
                    <p>In the event of a returned ACH (Non-Sufficient Funds) or a failed automated draw that requires manual intervention, a $50.00 bank disruption fee will be added to the balance, which will be in addition to any applicable administrative charges.  </p>
                    <br/>

                    <h2 className="title-2">Default and Collections </h2>
                    <p>If the payment is not brought current within 10 days of the applicable due date, interest will begin to accrue on the outstanding balance at the maximum legal rate allowed by applicable law. If the payments are not brought current within 30 days of the applicable due date, ACT then has the right to cancel the Agreement upon notice to the Client and the Client’s failure to cure within ten (10) days thereof.  ACT’s right to terminate shall be in addition to any other rights its may have against the Client to collect the debt or otherwise, as set forth in the Agreement or pursuant to applicable law.  If ACT has to refer this matter to a collection agency or initiate legal action to collect any amounts due hereunder or the Agreement, then ACT shall be entitled to recover from Client all costs incurred by ACT, including, but not limited to, collection agency fees, court costs, and attorneys’ fees, whether incurred pre-litigation, at the trial court level, on appeals, or in any proceeding to determine entitlement to and the amount of any such award of attorneys’ fees. </p>
                    <br/>
                    
                    <h2 className="title-2">Joint and Several Liability  </h2>
                    <p>If there is more than one Client, the Clients understand and agree that they are jointly and severally liable for the payment of all amounts due hereunder and the Agreement.   </p>
                    <br/>
               

                    

                    <h2 className="title-2">ACCEPTED AND AGREED: </h2>

                    

                    <p> Client ID: <b> {this.state.formData['Patient_ID__c']} </b>  </p>

                    

                    <p> Main Contact for Client Name:  <b> {this.state.formData['Name']} </b>   </p>

                    <div className="col-md-6 mb-3">
                            {/* <p></p> */}
                        <label>Main Contact for Client Signature: <span id="Signature"   className="act_required">*</span></label>
                        <SignatureCanvas  ref={(ref) => { this.sigPad = ref }} penColor='white' backgroundColor="gray"  canvasProps={{width: 500, height: 100, className: 'sigCanvas'}} />
                        <span style={{color: "red"}}> {this.state.errors["Signature"]}</span>
                        <div>
                            <button className="btn  btn-secondary" type="button"  onClick={this.clear}>
                            Clear
                            </button>  &nbsp;
                            <button className="btn btn-primary" type="button"  onClick={this.trim}>
                            Click to Confirm Signature
                            </button>
                            <span style={{color: "green",margin:"1%"}}> {this.state.success_sign_msg}</span>

                        </div> 
                        
                    </div>
                    
                   
       
                    <div className="choose-options-sec">
               
                    <button type="submit" className="btn btn-primary">Submit</button>
                    <br />
                    </div>           
                            </form>
                        </div>}
                    </div>
                </div>
                
            </MainLayout>
        );
    }
}



ForgotPassword.propTypes = {
    errors: PropTypes.object.isRequired,
    error: PropTypes.object.isRequired,
    updatePassword:PropTypes.func.isRequired,
    setPaymentInfo:PropTypes.func.isRequired,
    verifyClientData:PropTypes.func.isRequired,
    getClientAgreement:PropTypes.func.isRequired,
    setClientAgreement:PropTypes.func.isRequired,
    
    
};

const mapStateToProps = (state) => ({
    page_name : state.pay,
    errors: state.errors,
  });


export default connect(mapStateToProps, {updatePassword,getOtp,verifyClientData,setPaymentInfo,getClientAgreement,setClientAgreement})(ForgotPassword);